import { render, staticRenderFns } from "./FaturaDespesaForm.vue?vue&type=template&id=3bc9a452"
import script from "./FaturaDespesaForm.vue?vue&type=script&lang=js"
export * from "./FaturaDespesaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports